module.exports = __webpack_public_path__ + "img/impact.01a7d1b0.svg";